import {lazy} from '@aboutyou/lazy-imports';

export const TriggerLoginLegacySync = lazy(() =>
  import('./TriggerLoginLegacySync.eager').then(mod => ({
    default: mod.TriggerLoginLegacySync,
  })),
);
